<template>
  <md-steppers
    class="mb-3"
    :md-active-step.sync="active"
    md-vertical
    md-linear
    style="border-radius: 10px; box-shadow: none; padding: 0px"
  >
   <div style="margin-left:15px;margin-right:10px; margin-top:10px; wight:100%; text-align:justify">
          <p style="font-size:19px"><b>Un Ray</b></p>
          <p>Somos una aplicación móvil 100% Centroaméricana enfocada en brindar servicios profesionales de viajes personales y familiares, mandados o encomiendas asegurando que, cada uno de nuestros clientes queden agradecidos por el eficiente servicio recibido.</p>
          <p>Si cuentas con motocicleta o vehículo propio y quieres formar parte de nuestro alto equipo de <b>Conductores Un Ray</b>, qué esperas?</p>
          <p><b>¡AFÍLIATE!</b> Y obtendrás excelentes ingresos económicos.</p>
          <p>Cupo limitado</p>
        </div>
    <md-step
      class="md-step"
      id="first"
      md-label="Información personal"
      :md-error="secondStepError"
      :md-done.sync="first"
      style="padding: 0px; margin: 0px"
    >
      <div class="container" style="padding: 0px">
       
        <div class="main-body" style="padding: 0px">
          <div class="row gutters-sm" style="padding: 0px">
            <div class="col-md-6" style="margin: 0px">
              <div class="card mb-3" style="box-shadow: none">
                <div class="card-body" style="padding: 0px; margin: 0px">
                  <h5 class="text-center">Datos personales</h5>
                  <b-form
                    @submit="onSubmitProfile"
                    @reset="onResetProfile"
                    v-if="showProfile"
                    class="mt-2"
                  >
                    <b-form-group
                      id="input-group-ge"
                      label="Elegir Región: "
                      label-for="input-ge"
                      class="mt-3"
                    >
                      <b-form-select
                        v-model="formProfile.region"
                        :options="region"
                        required
                        style="width: 100%; border-radius: 5px; height: 35px"
                      ></b-form-select>
                    </b-form-group>
                    <b-form-group
                      id="input-group-nombre"
                      label="Nombre:"
                      label-for="input-n"
                      class="mt-3"
                    >
                      <b-form-input
                        id="input-n"
                        v-model="formProfile.nombre"
                        placeholder="Ingrese su nombre"
                        required
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      id="input-group-apellido"
                      label="Apellido:"
                      label-for="input-a"
                      class="mt-3"
                    >
                      <b-form-input
                        id="input-a"
                        v-model="formProfile.apellido"
                        placeholder="Ingrese su apellido"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      id="input-group-fecha"
                      label="Fecha Nacimiento:"
                      label-for="input-f"
                      class="mt-3"
                    >
                      <md-datepicker
                        format="MM/DD/YYYY"
                        v-model="fechaNacimiento"
                      >
                        <label>Seleccione fecha</label>
                      </md-datepicker>
                    </b-form-group>

                    <b-form-group
                      id="input-group-ge"
                      label="Género: "
                      label-for="input-ge"
                      class="mt-3"
                    >
                      <b-form-select
                        v-model="formProfile.genero"
                        :options="generos"
                        required
                        style="width: 100%; border-radius: 5px; height: 35px"
                      ></b-form-select>
                    </b-form-group>

                    <b-form-group
                      id="input-group-dpi"
                      label="DPI:"
                      label-for="input-d"
                      class="mt-3"
                    >
                      <b-form-input
                        id="input-dpi"
                        v-model="formProfile.dpi"
                        placeholder="Ingrese su DPI"
                        type="number"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      id="input-group-nit"
                      label="NIT:"
                      label-for="input-ni"
                      class="mt-3"
                    >
                      <b-form-input
                        id="input-ni"
                        v-model="formProfile.nit"
                        placeholder="Ingrese su NIT"
                        type="number"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      id="input-group-cel"
                      label="Celular:"
                      label-for="input-cel"
                      class="mt-3"
                    >
                      <b-form-input
                        id="input-cel"
                        v-model="formProfile.celular"
                        placeholder="Ingrese celular"
                        type="tel"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      id="input-group-correo"
                      label="Correo:"
                      type="email"
                      label-for="input-c"
                      class="mt-3"
                    >
                      <b-form-input
                        id="input-c"
                        v-model="formProfile.correo"
                        placeholder="Ingrese correo electrónico"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </b-form>
                </div>
              </div>
            </div>
            <div class="col-md-6 mb-4 mt-1">
              <h5 class="text-center">Cargar fotografías</h5>

              <div class="col-md-12 mb-3">
                <div class="card" style="box-shadow: none">
                  <div class="card-body">
                    
                      <div class="showhim"  style="position: absolute; top: 0px; right: 0px">
                        <span
                      class="material-icons" style="color: rgb(250, 164, 3)"
                     
                    >
                      info
                    </span>
  <div class="showme">
    <img class="avatar" src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"/></div>
</div>

                    <div
                      class="d-flex flex-column align-items-center text-center"
                    >
                      <span
                        v-if="fotoUsers.length > 0"
                        style="color: green; font-size: 48px"
                        class="material-icons"
                      >
                        check_circle_outline
                      </span>
                      <span
                        v-if="fotoUsers.length == 0"
                        style="color: gray; font-size: 48px"
                        class="material-icons"
                      >
                        highlight_off
                      </span>

                      <div class="mt-1">
                        <label class="custom-file-upload">
                          <input
                            type="file"
                            accept="image/png,image/jpeg"
                            @change="onLoad"
                          />
                          Elegir archivo
                        </label>

                        <h6 class="mt-1">Foto de perfil</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row gutters-sm mt-3">
                <div class="col-md-12 mb-3">
                  <div class="card" style="box-shadow: none">
                    <div class="card-body">
                      <div
                        class="
                          d-flex
                          flex-column
                          align-items-center
                          text-center
                        "
                      >
                        <span
                          v-if="fotoLFs.length > 0"
                          style="color: green; font-size: 48px"
                          class="material-icons"
                        >
                          check_circle_outline
                        </span>
                        <span
                          v-if="fotoLFs.length == 0"
                          style="color: gray; font-size: 48px"
                          class="material-icons"
                        >
                          highlight_off
                        </span>
                        <div class="mt-1" text-center>
                          <label class="custom-file-upload">
                            <input
                              type="file"
                              accept="image/png,image/jpeg"
                              @change="onLoadLF"
                            />
                            Elegir archivo
                          </label>
                          <h6 class="mt-1">Licencia de conducir(Parte frontal)</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 mb-3">
                  <div class="card" style="box-shadow: none">
                    <div class="card-body">
                      <div
                        class="
                          d-flex
                          flex-column
                          align-items-center
                          text-center
                        "
                      >
                        <span
                          v-if="fotoLTs.length > 0"
                          style="color: green; font-size: 48px"
                          class="material-icons"
                        >
                          check_circle_outline
                        </span>
                        <span
                          v-if="fotoLTs.length == 0"
                          style="color: gray; font-size: 48px"
                          class="material-icons"
                        >
                          highlight_off
                        </span>

                        <div class="mt-1">
                          <label class="custom-file-upload">
                            <input
                              type="file"
                              accept="image/png,image/jpeg"
                              @change="onLoadLT"
                            />
                            Elegir archivo</label
                          >

                          <h6 class="mt-1">Licencia de conducir (Parte trasera)</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 mb-3">
                  <div class="card" style="box-shadow: none">
                    <div class="card-body">
                      <div
                        class="
                          d-flex
                          flex-column
                          align-items-center
                          text-center
                        "
                      >
                        <span
                          v-if="fotoTFs.length > 0"
                          style="color: green; font-size: 48px"
                          class="material-icons"
                        >
                          check_circle_outline
                        </span>
                        <span
                          v-if="fotoTFs.length == 0"
                          style="color: gray; font-size: 48px"
                          class="material-icons"
                        >
                          highlight_off
                        </span>
                        <div class="mt-1">
                          <label class="custom-file-upload">
                            <input
                              title="Choose a video please"
                              type="file"
                              accept="image/png,image/jpeg"
                              @change="onLoadTF"
                            />
                            Elegir archivo
                          </label>

                          <h6 class="mt-1">Tarjeta Circulación (Parte frontal)</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 mb-3">
                  <div class="card" style="box-shadow: none">
                    <div class="card-body">
                      <div
                        class="
                          d-flex
                          flex-column
                          align-items-center
                          text-center
                        "
                      >
                        <span
                          v-if="fotoTTs.length > 0"
                          style="color: green; font-size: 48px"
                          class="material-icons"
                        >
                          check_circle_outline
                        </span>
                        <span
                          v-if="fotoTTs.length == 0"
                          style="color: gray; font-size: 48px"
                          class="material-icons"
                        >
                          highlight_off
                        </span>
                        <div class="mt-1" style="padding: 5px">
                          <label class="custom-file-upload">
                            <input
                              type="file"
                              accept="image/png,image/jpeg"
                              @change="onLoadTT"
                            />
                            Elegir archivo
                          </label>

                          <h6 class="mt-1">Tarjeta Circulacion (Parte trasera)</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <b-card class="mt-3" header="Form Data Result">
            <pre class="m-0">{{ formProfile }}</pre>
             <pre class="m-0">{{ fechaNacimiento }}</pre>
            </b-card> -->
        </div>
      </div>

      <md-button
        style="
          text-align: left;
          width: 100px;
          border: solid 2px orangered;
          color: orangered;
          background: #ffff;
          border-radius: 8px;
          float: right;
        "
        class="md-raised md-primary"
        @click="setDone('first', 'second')"
        >Continue
      </md-button>
    </md-step>

    <!--Segundo modulo  *************************************************************************************************-->
    <md-step
      id="second"
      md-color="orange"
      md-label="Vehículo"
      :md-error="secondStepError"
      :md-done.sync="second"
    >
      <b-form
        @submit="onSubmitAfil"
        @reset="onResetAfil"
        v-if="showMarca"
        class="mt-4"
      >
        <b-form-group
          id="input-group-M"
          label="¿Cómo deseas generar ingresos?:"
          label-for="input-M"
          class="mt-3 mb-3"
        >
          <b-form-select
            id="input-M"
            v-model="formMarca.conductor"
            :options="tipos"
            required
            style="width: 100%; border-radius: 5px; height: 35px"
          ></b-form-select>
        </b-form-group>

        <b-form-group
          id="input-group-M"
          label="Fotografía del vehículo: "
          label-for="input-M"
          class="mt-4 mb-2"
        >
          <div class="card mt-1 mb-2" style="box-shadow: none">
            <div class="card-body" style="padding: 0px; margin: 0px">
              <div class="tooltip-wrap">
                <span class="material-icons icon-help" style="color: orangered"
                  >help</span
                >
                <div class="tooltip-content">
                  <img
                    class="img-src"
                    src="https://cs.copart.com/v1/AUTH_svc.pdoc00001/PIX166/51083e0c-37c4-45c4-aa85-c20143f4ea17.JPG"
                    alt="Some Image"
                  />
                  <p style="margin: 0px; padding: 0px; font-weight: bolder">
                    Ejemplo de vehículo
                  </p>
                </div>
              </div>

              <div class="d-flex flex-column align-items-center text-center">
                <span
                  v-if="fotoVs.length > 0"
                  style="color: green; font-size: 48px"
                  class="material-icons"
                >
                  check_circle_outline
                </span>
                <span
                  v-if="fotoVs.length == 0"
                  style="color: gray; font-size: 48px"
                  class="material-icons"
                >
                  highlight_off
                </span>
                <div class="mt-1">
                  <label class="custom-file-upload">
                    <input
                      type="file"
                      accept="image/png,image/jpeg"
                      @change="onLoadV"
                    />
                    Elegir archivo
                  </label>

                  <h6 class="mt-1">Foto del vehículo</h6>
                </div>
              </div>
            </div>
          </div>
        </b-form-group>

        <b-form-group
          id="input-group-Marca"
          label="Marca del vehículo:  Ejemplo: Toyota, Nissan, etc. "
          label-for="input-Marca"
          class="mt-3"
        >
          <b-form-input
            id="input-Marca"
            v-model="formMarca.marca"
            placeholder="Ingrese la marca"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-Linea"
          label="Línea del vehículo: Ejemplo: Hilux, Rav4, etc."
          label-for="input-l"
          class="mt-3"
        >
          <b-form-input
            id="input-l"
            v-model="formMarca.linea"
            placeholder="Ingrese la línea"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-placa"
          label="No. de placa del vehículo:"
          label-for="input-p"
          class="mt-3"
        >
          <b-form-input
            id="input-p"
            v-model="formMarca.placa"
            placeholder="Ingrese no. placa"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-C"
          label="Color del vehículo: "
          label-for="input-M"
          class="mt-3 mb-3"
        >
          <b-form-select
            id="input-C"
            v-model="formMarca.color"
            :options="colores"
            required
            style="width: 100%; border-radius: 5px; height: 35px"
          ></b-form-select>
          <label class="mt-2"
            >Si no aparece en el listado anterior, escribelo:</label
          >
          <b-form-input
            class="mt-1"
            id="input-p"
            v-model="formMarca.color"
            placeholder="Escribe color"
            required
          ></b-form-input>
        </b-form-group>

        <!--<b-button type="submit" variant="primary">Submit</b-button>
              <b-button type="reset" variant="danger">Reset</b-button>

              -->
      </b-form>

      <!--ALERT SATISFACTORIO-->
      <md-dialog-alert
        :md-active.sync="alertVacioSecond"
        md-title="¡Campos vacíos!"
        md-content="Asegúrate que ninguno de los campos este vacío."
        md-confirm-text="Ok"
      />
      <md-button
        style="
          text-align: left;
          width: 100px;
          border: solid 2px orangered;
          color: orangered;
          background: #ffff;
          border-radius: 8px;
          float: right;
        "
        class="md-raised md-primary"
        @click="setDoneSecond('second', 'third')"
        >Continue</md-button
      >

      <!--  <b-card class="mt-3" header="Form Data Result">
            <pre class="m-0">{{ formMarca }}</pre>
            </b-card> -->
    </md-step>

    <md-step
      id="third"
      md-label="Finalizar Solicitud"
      :md-error="secondStepError"
      :md-done.sync="third"
    >
      <md-empty-state
        class="md-primary mt-1 mb-3"
        md-icon="done"
        md-label="Formulario completado"
        md-description="Has completado los datos solicitados."
      >
        <label v-if="envioSoli == false" for="checkbox">
          <input
            v-if="envioSoli == false"
            type="checkbox"
            id="checkbox"
            v-model="aceptarTerminos"
          />
          He leído y acepto los
        </label>
        <a style="cursor: pointer; margin-top: 1px" @click="activarTC()"
          >Términos y Condiciones</a
        >
        <br />
        <md-button
          :disabled="!aceptarTerminos"
          @click="enviarSolicitud()"
          class="md-raised md-accent btn-confirmarSpinner"
          v-if="envioSoli == false"
        >
          <span
            v-if="activarSpinner == true"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Confirmar Solicitud
        </md-button>
        <p style="font" v-if="activarSpinner == true">
          Espera, esto puede tardar unos minutos...
        </p>
      </md-empty-state>

      <!-- DIALOGO PARA DECIFIDR SI ENVIAR O NO LA SOLICITUD-->
      <md-dialog-confirm
        :md-active.sync="activeDialogSolicitud"
        md-title="¿Estás seguro de enviar la solicitud?"
        md-content="Al enviar esta solicitud nos estas dando derecho a que podamos evaluar tu infomación brindada."
        md-confirm-text="Confirmar Envío"
        md-cancel-text="Cancelar"
        @md-cancel="onCancelSolicitud"
        @md-confirm="confirmarSolicitud"
      />

      <!--ALERT SATISFACTORIO-->
      <!--<md-dialog-alert
                :md-active.sync="alertEnvioS"
                md-title="¡Solicitud Enviada!"
                md-content="Se ha enviado con éxito tu <strong>Solicitud para Conductor</strong>, espera prontas respuestas a tu correo electrónico."
                md-confirm-text="Ok"
               @md-confirm="probarAler"
              /> -->

      <md-dialog
        :md-active.sync="alertEnvioS"
        :md-fullscreen="full"
        :md-click-outside-to-close="close"
      >
        <md-dialog-content style="text-align: center">
          <span
            style="color: green; font-size: 58px; text-align: center"
            class="material-icons"
          >
            check_circle_outline
          </span>
          <h1>¡Solicitud enviada!</h1>
          <h6>
            Se ha enviado con éxito tu
            <strong>Solicitud para Conductor</strong>, espera prontas respuestas
            en tu correo electrónico.
          </h6>
        </md-dialog-content>

        <md-dialog-actions>
          <md-button class="md-primary" @click="refrescarPage"
            ><a href="#/">Ok</a></md-button
          >
        </md-dialog-actions>
      </md-dialog>

      <!--ALERT ERROR-->
      <md-dialog-alert
        :md-active.sync="alertEnvioE"
        md-title="¡Error de envio!"
        md-content="Lamentamos los inconvenientes, Vuelve a intentar más tarde."
        md-confirm-text="Ok"
      />

      <!--ALERT INFOMRA NUEVA SOLICITUS-->
      <md-dialog-alert
        :md-active.sync="alertInforma"
        md-title="¡Información!"
        md-content="Ten en cuenta que para enviar una nueva solicitud  para <strong>Conductor de un Ray</strong>, te invitamos a descargar nuestra app <strong>Un Ray</strong> y desde <strong>Modo Conductor</strong> crear tu solicitud. Ingresando con tu correo y contraseña, ingresada en el primer paso de este proceso."
        md-confirm-text="Ok"
      />

      <div>
        <md-dialog
          :md-active.sync="showDialog"
          :md-fullscreen="full"
          :md-click-outside-to-close="close"
        >
          <md-dialog-content style="padding: 2px; padding-top: 10px">
            <div class="wrapper">
              <pdf
                v-for="i in numPages"
                :key="i"
                :src="src"
                :page="i"
                style="height: 100%; margin-bottom: 0px; padding: 0px"
              ></pdf>
            </div>
          </md-dialog-content>
          <md-dialog-actions>
            <md-button class="md-primary" @click="showDialog = false"
              >Salir</md-button
            >
          </md-dialog-actions>
        </md-dialog>
      </div>
    </md-step>
  </md-steppers>
</template>


<script>
import navbarAfilia from "../components/navbarAfilia.vue";
import VuePassword from "vue-password";
import jsPDF from "jspdf";
import pdf from "vue-pdf";
import FirebaseService from "../services/firebaseservice.js";
import VueBase64FileUpload from "vue-base64-file-upload";

import { mdbFooter, mdbContainer, mdbRow, mdbCol } from "mdbvue";
import firebase from "firebase/app";
import moment from "moment";
import "firebase/storage";
import "firebase/app";
import "firebase/auth";

var pdfDocument = pdf.createLoadingTask("static/terminos_condiciones.pdf");

export default {
  components: {
    navbarAfilia,
    VuePassword,
    VueBase64FileUpload,
    pdf,
    mdbFooter,
    mdbContainer,
    mdbRow,
    mdbCol,
  }, //src="../assets/terminos_condiciones.pdf"

  name: "Mdsteppers",
  data() {
    return {
      src: null,
      numPages: undefined,
      sig: 1,

      full: false,
      fullTnc: true,
      close: false,

      currentPage: 0,
      pageCount: 0,
      radio: false,
      image: {
        size: "",
        height: "",
        width: "",
      },
      imageLoaded: false,
      showDialog: false,
      foto: "",
      previewImage: null,
      customImageMaxSize: 3,
      marcas: [{ text: "Seleccione", value: null }],
      rays: [{ text: "Seleccione", value: null }],
      raysOptions: [],
      placeholder: null,
      aceptarTerminos: false,

      activarSpinner: false,
      alertSatisfac: false,
      alertError: false,
      alertErrorEmail: false,
      alertUseEmail: false,
      alertEnvioS: false,
      alertEnvioE: false,
      alertVacioSecond: false,
      activeDialogSolicitud: false,
      alertInforma: false,
      envioSoli: false,
      idUser: "",
      tooltipActive: false,
      type: "password",
      btnText: "eye-slash-fill",
      strength: 0,
      fotoLF: null,
      fotoLT: null,
      fotoTF: null,
      fotoTT: null,
      fotoV: null,

      fotoVs: "",
      fotoLFs: "",
      fotoLTs: "",
      fotoTFs: "",
      fotoTTs: "",
      fotoUsers: "",

      formMarca: {
        conductor: null,
        color: null,
        marca: null,
        linea: "",
        placa: "",
      },

      fechaNacimiento: null,

      formProfile: {
        nombre: "",
        apellido: "",
        genero: null,
        correo: "",
        dpi: "",
        nit: "",
        celular: "",
        fechaNacimiento: null,
        fotoUser: null,
        id: 1,
        verificado: "no",
        region: null,
      },

      form: {
        email: "",
        // name: "",
        // conductor: null,
        genero: null,
        password: "",
      },
      tipos: [
        { text: "Seleccione", value: null },
        { text: "Un Ray (Modelo menor a 2015)", value: "Un Ray" },
        { text: "Ray Plus (Modelo 2015 +)", value: "Ray Plus" },
        { text: "Mandaditos al  Ray", value: "Mandaditos" },
        { text: "Moto Ray", value: "Moto Ray" },
      ],
      colores: [
        { text: "Seleccione", value: null },
        "Azul",
        "Amarillo",
        "Anaranjado",
        "Blanco",
        "Cafes",
        "Corinto",
        "Cromado",
        "Fucsia",
        "Fosforecente",
        "Morado",
        "Rosado",
        "Negro",
        "Rojo",
        "Rosado",
        "Verde",
      ],
      generos: [{ text: "Seleccione", value: null }, "Masculino", "Femenino"],
      region: [{ text: "Seleccione", value: null }, "Coatepeque"],
      show: true,
      showMarca: true,
      showProfile: true,

      active: "first",
      first: false,
      second: false,
      third: false,
      four: false,
      five: false,
      six: false,
      secondStepError: null,
    };
  },
  methods: {
    refrescarPage() {
      console.log("Presione");
      this.alertEnvioS = false;
      // this.$router.go(0);
      // this.$router.('afiliacionRay')
      window.location.href = "/";
      //this.$forceUpdate();
    },
    next() {
      this.sig = this.sig + 1;
    },
    back() {
      if (this.sig > 1) {
        this.sig = this.sig - 1;
      } else if (this.sig == 1) {
        this.sig = 1;
      }
    },
    exportPDF() {
      var vm = this;
      var columns = [
        { title: "Nombre", dataKey: "nombre" },
        { title: "Acumulado (Q.)", dataKey: "costo" },
        { title: "Fecha", dataKey: "fecha" },
      ];
      var doc = new jsPDF("p", "pt");
      doc.text("Estado de cuentas", 40, 40);
      doc.autoTable(columns, vm.searched, {
        margin: { top: 60 },
      });
      doc.save("estado.pdf");
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },
    presionar() {
      this.$router.replace("/afiliacion").catch(() => {});
    },
    setDoneSecond(id, index) {
      if (
        this.formMarca.color != null &&
        this.formMarca.conductor != null &&
        this.formMarca.marca != null &&
        this.formMarca.linea != "" &&
        this.formMarca.placa != ""
      ) {
        this[id] = true;
        this.secondStepError = null;

        if (index) {
          this.active = index;
        }
      } else if (
        this.formMarca.color == null ||
        this.formMarca.conductor == null ||
        this.formMarca.marca == null ||
        this.formMarca.linea == "" ||
        this.formMarca.placa == ""
      ) {
        this.alertVacioSecond = true;
      }

      /*
      formMarca: {
        conductor: null,
        color: null,
        marca: null,
        linea: "",
        placa: "",
      },
      */
    },
    /* */

    onFileV(file) {
      //console.log(file); // file object
      //console.log("LICEN TRALT : ", file);
    },

    onLoadV(e) {
      console.log("LICEN TRA : ", e); // data-uri string
      if (e.target.files[0] == "undefined" || e.target.files[0] == undefined) {
        this.fotoV =
          "https://cs.copart.com/v1/AUTH_svc.pdoc00001/PIX166/51083e0c-37c4-45c4-aa85-c20143f4ea17.JPG";
        this.fotoVs = "";
      } else if (
        e.target.files[0] != "undefined" ||
        e.target.files[0] != undefined
      ) {
        this.fotoVs = e.target.files[0].name;
        const image = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = (e) => {
          this.fotoV = e.target.result;
          //console.log(e.target.result);
          //  console.log(this.previewImage);
        };
      }
    },

    /** */
    onFileTT(file) {
      //console.log(file); // file object
      //console.log("LICEN TRALT : ", file);
    },

    onLoadTT(e) {
      console.log("LICEN TRA : ", e); // data-uri string
      if (e.target.files[0] == "undefined" || e.target.files[0] == undefined) {
        this.fotoTT = null;
        this.fotoTTs = "";
      } else if (
        e.target.files[0] != "undefined" ||
        e.target.files[0] != undefined
      ) {
        this.fotoTTs = e.target.files[0].name;
        const image = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = (e) => {
          this.fotoTT = e.target.result;
          //console.log(e.target.result);
          //  console.log(this.previewImage);
        };
      }
    },
    /* */

    /* */
    onFileTF(file) {
      //console.log(file); // file object
      //console.log("LICEN FRON : ", file);
    },

    onLoadTF(e) {
      //  console.log(e, e.target.files[0]);
      /*  if(e.target.files[0]=='undefined' || e.target.files[0]==undefined){

      } else if(e.target.files[0]!='undefined' || e.target.files[0]!=undefined){

      }  */
      //  console.log("LICEN FRON : ", dataUri); // data-uri string
      //  this.fotoTF = dataUri;

      if (e.target.files[0] == "undefined" || e.target.files[0] == undefined) {
        this.fotoTF = null;
        this.fotoTFs = "";
      } else if (
        e.target.files[0] != "undefined" ||
        e.target.files[0] != undefined
      ) {
        this.fotoTFs = e.target.files[0].name;
        const image = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = (e) => {
          this.fotoTF = e.target.result;
          //  console.log(e.target.result);
        };
      }
    },
    /* */

    /* */
    onFileLF(file) {
      // console.log(file); // file object
      // console.log("LICEN FRON : ", file);
    },

    onLoadLF(e) {
      //console.log("LICEN FRON : ", dataUri); // data-uri string
      //this.fotoLF = dataUri;

      if (e.target.files[0] == "undefined" || e.target.files[0] == undefined) {
        this.fotoLF = null;
        this.fotoLFs = "";
      } else if (
        e.target.files[0] != "undefined" ||
        e.target.files[0] != undefined
      ) {
        this.fotoLFs = e.target.files[0].name;
        const image = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = (e) => {
          this.fotoLF = e.target.result;
          // console.log(e.target.result);
        };
      }
    },
    /* */

    /* */
    onFileLT(file) {},

    onLoadLT(e) {
      // console.log("LICEN TRA : ", dataUri); // data-uri string
      // this.fotoLT = dataUri;
      if (e.target.files[0] == "undefined" || e.target.files[0] == undefined) {
        this.fotoLT = null;
        this.fotoLTs = "";
      } else if (
        e.target.files[0] != "undefined" ||
        e.target.files[0] != undefined
      ) {
        this.fotoLTs = e.target.files[0].name;
        const image = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = (e) => {
          this.fotoLT = e.target.result;
        };
      }
    },
    /* */

    onFile(file) {},

    onLoad(e) {
      // console.log(dataUri); // data-uri string
      // this.foto = dataUri;
      // this.formProfile.fotoUser = dataUri;
      if (e.target.files[0] == "undefined" || e.target.files[0] == undefined) {
        this.formProfile.fotoUser = null;
        this.fotoUsers = "";
      } else if (
        e.target.files[0] != "undefined" ||
        e.target.files[0] != undefined
      ) {
        this.fotoUsers = e.target.files[0].name;
        const image = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = (e) => {
          this.formProfile.fotoUser = e.target.result;
        };
      }
    },

    onSizeExceeded(size) {
      alert(
        `Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`
      );
    },
    onSubmitAfil(event) {},
    onSubmit(event) {
      event.preventDefault();

      //alert(JSON.stringify(this.form));
      FirebaseService.registerUser(
        this.form.email,
        this.form.password,
        this.form.genero
      )
        .then((data) => {
          //  this.idUser = data.user.uid;
          this.alertSatisfac = true;

          firebase
            .auth()
            .signInWithEmailAndPassword(this.form.email, this.form.password)
            .then((data) => {
              this.setDone2("first", "second");
              this.idUser = data.user.uid;
            });
        })
        .catch((err) => {
          if (err.code == "auth/email-already-in-use") {
            this.alertError = true;
          } else if (err.code == "auth/invalid-email") {
            //auth/email-already-exists
            this.alertErrorEmail = true;
          } else if (err.code == "auth/email-already-exists") {
            //
            this.alertUseEmail = true;
          }
        });
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.genero = null;
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    onResetAfil(event) {},

    onSubmitProfile(event) {},
    onResetProfile() {},

    onConfirm() {
      console.log("Datos ingresados");
      var id = "first";
      var index = "second";
      this[id] = true;

      this.secondStepError = null;

      if (index) {
        this.active = index;
      }
    },

    setDone2(id, index) {
      this[id] = true;

      this.secondStepError = null;

      if (index) {
        this.active = index;
      }
    },

    setDone(id, index) {
      this[id] = true;

      this.secondStepError = null;

      if (index) {
        this.active = index;
      }
    },

    /*
    setDone(id, index) {
      if (
        this.formProfile.nombre == "" ||
        this.formProfile.apellido == "" ||
        this.formProfile.genero == null ||
        this.formProfile.correo == "" ||
        this.formProfile.dpi == "" ||
        this.formProfile.nit == "" ||
        this.formProfile.celular == "" ||
        this.fechaNacimiento == null 
      ) {
        this.alertVacioSecond = true;
      } else {
        this[id] = true;

        this.secondStepError = null;

        if (index) {
          this.active = index;
        }
      }
    },
    */
    setError() {
      this.secondStepError = "This is an error!";
    },
    showPassword() {
      if (this.type === "password") {
        this.type = "text";
        this.btnText = "eye-fill";
      } else {
        this.type = "password";
        this.btnText = "eye-slash-fill";
      }
    },

    onDataChange(items) {
      let _tutorials = [];
      let _data = [];

      items.forEach((item) => {
        let key = item.id;
        let data = item.val();
        _data.push(data);

        this.marcas.push({
          text: data.marca,
          value: data.marca,
        });
      });
      // this.rays =  this.raysOptions;
      //
    },

    onCancelSolicitud() {
      /* FirebaseService.removerUserFBS(this.idUser).then(()=>{

  })*/
      this.$router.replace("/").catch(() => {});
      this.alertInforma = true;
    },
    enviarSolicitud() {
      this.activeDialogSolicitud = true;
    },

    confirmarSolicitud() {
      this.activarSpinner = true;
      let solicitud = {
        id: Math.random().toString().substring(2, 15),
        docSolicitados: "vacio",
        comentario: "Sin comentario",
        statusSolicDoc: "Sin Solicitar",
        passwordTemporal: "vacio",
        fechaEnvio: moment(new Date()).format("DD-MM-YYYY"),
        fecha: moment(new Date()).format("YYYY-MM-DD"),
        fechaHora: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        fechagestion: "vacio",
        gestionadopor: "ninguno",
        no_gestion: Math.random().toString().substring(2, 15),
        paso: "first",
        status: "Verificación",
        cargasAdicionales: {
          antecedePenales: "ninguno",
          antecedePolicia: "ninguno",
          dpiF: "ninguno",
          dpiP: "ninguno",
          dpiT: "ninguno",
          fotoA: "ninguno",
          fotoperfil: "ninguno",
          licenciaFrontal: "ninguno",
          licenciatrasera: "ninguno",
          tarjetaCirculac: "ninguno",
          tarjetaCirculacT: "ninguno",
          vehiculo: "ninguno",
        },
        acercaDeMi: [
          {
            apellido: this.formProfile.apellido,
            celular: this.formProfile.celular,
            correo: this.formProfile.correo,
            dpi: this.formProfile.dpi,
            fechaNacimiento: moment(this.fechaNacimiento).format("DD/MM/YYYY"),
            fotoUser: this.formProfile.fotoUser,
            genero: this.formProfile.genero,
            id: 1,
            nit: this.formProfile.nit,
            nombre: this.formProfile.nombre,
            region: this.formProfile.region,
            verificado: "No",
          },
        ],

        licenciaConducir: [
          {
            licenciaConducir: "vacio",
            foto_delantera: this.fotoLF,
            foto_trasera: this.fotoLT,
            id: 1,
            numero_licencia: "vacio",
            verificado: "No",
          },
        ],
        tarjetaCirculacion: [
          {
            foto_delantera: this.fotoTF,
            foto_trasera: this.fotoTT,
            id: 1,
            verificado: "No",
          },
        ],
        vehiculo: {
          colorVehi: this.formMarca.color,
          linea: this.formMarca.linea,
          marcaVehi: this.formMarca.marca,
          numPlaca: this.formMarca.placa,
          fotoVehi: this.fotoV,
          verificado: "No",
        },
        tipoVehiculo: [
          {
            id: 1,
            tipo: this.formMarca.conductor,
          },
        ],
      };

      FirebaseService.guardarSolicitudNormal(solicitud)
        .then(() => {
          this.alertEnvioS = true;
          this.activarSpinner = false;
          this.envioSoli = true;
          //this.$router.replace("/finalizado").catch(() => {});
        })
        .catch((e) => {
          console.log("Error obtenido : ", e);
          this.activarSpinner = false;
          this.alertEnvioE = true;
        });
    },

    activarTC() {
      this.showDialog = true;
      var pdfDocument = pdf.createLoadingTask(
        "static/terminos_condiciones.pdf"
      );
      this.src = pdfDocument;
      this.src.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
    },
  },

  mounted() {
    // this.$router.replace("/").catch(() => {});
    this.fotoV =
      "https://cs.copart.com/v1/AUTH_svc.pdoc00001/PIX166/51083e0c-37c4-45c4-aa85-c20143f4ea17.JPG";
  },
  beforeDestroy() {
    // this.$router.replace("/").catch(() => {});
  },
};
</script>

<style  scoped>
.btn-continuar {
  float: right;
  border-radius: 5px;
  right: 2px;
  bottom: 0px;
  background: orangered;
}

.btn-contrasena {
  position: absolute;
  top: 35%;
  right: 0px;
  background: none;
  box-shadow: none;
  bottom: 5px;
}

.btn-input {
  position: relative;
}

.btn-submit {
}

/* dadaldkfñal */

body {
  margin-top: 20px;
  color: #1a202c;
  text-align: left;
  background-color: #e2e8f0;
}
.main-body {
  padding: 15px;
}
.card {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1rem;
}

.gutters-sm {
  margin-right: -8px;
  margin-left: -8px;
}

.gutters-sm > .col,
.gutters-sm > [class*="col-"] {
  padding-right: 8px;
  padding-left: 8px;
}
.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.bg-gray-300 {
  background-color: #e2e8f0;
}
.h-100 {
  height: 100% !important;
}
.shadow-none {
  box-shadow: none !important;
}

.btn-bajar {
  z-index: 2;
  position: fixed;
  bottom: 10%;
}

.div-h {
  height: 200px;
}

.vendor_logo_hide {
  display: inline !important;
  color: transparent;
  width: 99px;
}

.vendor_logo {
  display: block !important;
  color: black;
  width: 100%;
}

.btn-confirmarSpinner {
  color: orangered;
  border-radius: 8px;
  font-weight: bolder;
}

.conta-content {
}
.titulo {
  margin-top: 40px;
  font-family: "Rachell", Helvetica, Arial;
  font-size: 35px;

  z-index: 2;
  color: #ffff;
  margin-left: 10px;
}

.portada {
  background: url(../assets/portada.jpg) no-repeat;
  position: relative;
  background-size: cover;
}

.md-app-d {
  border-radius: 8px;
}

.md-content {
  margin-top: 10px;
  padding-left: -5px;
}

.md-til {
}

.div-message {
  height: auto;
  margin-bottom: 90px;
  font-weight: bolder;
  background: rgba(155, 155, 155, 0.6);
  padding: 3px;
  border-radius: 5px;
}

.message {
  font-weight: bolder;
  font-size: 15px;
}

/* */
/**/
.p-titulo {
  color: #ffff;
  font-family: "Rachell", Helvetica, Arial;
  font-weight: bolder;
  font-size: 74px;
  margin-bottom: 0px;
}

.p-mensaje {
  font-family: Helvetica, Arial;
  color: #ffff;
  padding: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.div-titulo {
  margin-left: 10px;
  margin-top: -75%;
}

/** */

body {
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: "Overpass", sans-serif;
  letter-spacing: 0px;
  font-size: 17px;
  color: #8d8f90;
  font-weight: 400;
  line-height: 32px;
  background-color: #edefef;
}

ul,
ol {
}
a {
  text-decoration: none;
  color: #8d8f90;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}
a:focus,
a:hover {
  text-decoration: none;
  color: #f85759;
}

.page-header {
  background: url(../assets/portada.jpg) no-repeat;
  position: relative;
  background-size: cover;
}

.page-headers {
  background: url(../assets/portada.jpg) no-repeat;
  position: relative;
  background-size: cover;
}
.page-caption {
  padding-top: 15px;
  padding-bottom: 120px;
  padding-left: -3px;
}
.page-title {
  font-size: 28px;
  line-height: 1;
  margin-top: 5px;
  color: #fff;
  font-weight: bolder;
  text-align: left;
  font-family: "Rachell", Helvetica, Arial;
  background: rgb(19, 24, 19, 0.5);
  width: 205px;
  padding: 5px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-bottom: -0.513px;
}
.page-subtitle {
  margin-top: 0px;
  font-size: 13px;
  text-align: left;
  color: #fff;
  font-weight: bolder;
  background: rgb(19, 24, 19, 0.5);
  width: 205px;
  padding: 5px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.card-section {
  padding: 0px;
  position: relative;
  bottom: 90px;
  border-radius: 10px;
  background: transparent !important;
}
.card-block {
  padding: 80px;
}
.section-title {
  margin-bottom: 60px;
}

.page-servicios {
  text-align: center;
  font-weight: bolder;
  margin-top: 5px;
  margin-bottom: 16px;
}

.row-div {
  border-radius: 8px;
}

.div-body {
  background: rgb(235, 235, 235);
}

.div-descargar {
  position: absolute;
  right: 8px;
  top: 8px;
  height: 40px;
}

.card-div {
  color: rgb(97, 97, 97);
  border: none !important;
}

.box:hover {
  background: rgb(0, 172, 0); /* make this whatever you want */
}

.wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -moz-overflow-scrolling: touch;
  -ms-overflow-scrolling: touch;
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid orangered;
  display: inline-block;
  color: orangered;
  font-weight: bolder;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 8px;
}

.custom-file-upload:hover {
  background: orangered;
  color: #fff;
}

.md-step {
}

.estilo-foto {
  margin-left: 0px;
  padding-left: 0px;
  width: 150px;
  height: 140px;
  margin-left: 0px;
  background-position: 100px 50px;
}

.img-src {
  padding-top: 3px;
  height: 90px;
  width: 100px;
  border-radius: 5px;
  background-size: cover;
  background-position: center;
}

.p-foto {
  font-size: 10px;
}

.warning {
  position: absolute;
  right: 0px;
  color: orangered;
  top: 0px;
}

.tooltip-wrap {
  position: relative;
  right: 0px;
  margin: 0px;
}

.tooltip-wrap .tooltip-content {
  text-align: center;
  width: 60%;
  display: none;
  position: absolute;
  bottom: 9%;
  left: 6%;
  right: 5%;
  background-color: rgb(245, 243, 243);
  padding: 0.4em;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.tooltip-wrap:hover .tooltip-content {
  display: block;
}

/**

const firebaseConfig = {
  apiKey: "AIzaSyAlWefcg2svYOseKMMjcUzgZKY9s8skOqo",
  authDomain: "unray202109.firebaseapp.com",
  databaseURL: "https://unray202109-default-rtdb.firebaseio.com",
  projectId: "unray202109",
  storageBucket: "unray202109.appspot.com",
  messagingSenderId: "129152219966",
  appId: "1:129152219966:web:cae6e81b752184e043ca6f",
  measurementId: "G-D9ZVYKEX38"
};
 */

 .info {
}
    
.info:hover + .div-sprint {
    display: block;
}

.showme {
  display: none;
}

.showhim:hover .showme {
  position:absolute;
  top:9px;
  right:20px;
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 5px;
}

.avatar{
 width: 100%;
  height: 100%;
  object-fit: cover;
  border-end-end-radius: 5px;
  border-end-start-radius: 5px;
  border-top-left-radius: 5px;
}

.close:after .showme{
  display: none;

color: rgb(250, 164, 3)
}
</style>


// WEBPACK FOOTER //
// src/components/Mdsteppers.vue